/**
 * Dialog de clôture de l'OR (refonte iter92).
 *
 * Présenté quand l'OR est en statut 'travaux_effectue'. L'atelier / le comptoir
 * déclare simplement "Travaux terminés" : le dossier part dans la file
 * "Factures à émettre" (Facturation). PLUS AUCUNE décision de facturation ici —
 * le canal d'émission (Caisse / Mail / Lixt / Courrier / Hybride) est choisi
 * dans Facturation au moment d'émettre.
 *
 * On en profite pour enregistrer les intervenants (mécaniciens + heures)
 * qui alimentent les statistiques atelier.
 */
import { Dialog, DialogContent, DialogHeader, DialogFooter, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2, Users, CheckCircle2 } from "lucide-react";
import IntervenantsEditor from "@/components/IntervenantsEditor";

export default function OrFinaliserDialog({
  open,
  onClose,
  or,
  draft,
  setDraft,
  mecaniciens,
  finalSubmitting,
  onChooseFinaliser,
}) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>Travaux terminés — clôturer le dossier</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="text-sm text-gray-600">
            Travaux terminés sur <strong>{or.vehicule_label}</strong>.
            <span className="ml-1 font-mono font-bold text-gray-900">
              {or.totaux?.total_ttc?.toFixed(2)} CHF TTC
            </span>
          </div>

          <div className="bg-amber-50/60 border border-amber-200 rounded-lg p-3">
            <div className="text-xs font-semibold text-amber-900 uppercase tracking-wider flex items-center gap-1 mb-2">
              <Users className="w-3.5 h-3.5" /> Suivi atelier
            </div>
            <IntervenantsEditor
              intervenants={draft?.intervenants || []}
              setIntervenants={(next) => setDraft((d) => ({ ...d, intervenants: next }))}
              mecaniciens={mecaniciens}
              compact
            />
            <div className="text-[10px] text-gray-500 mt-2">
              💡 Ces infos alimentent les statistiques par mécanicien (CA réparti au prorata des heures).
            </div>
          </div>

          <button
            onClick={() => onChooseFinaliser("30j")}
            disabled={finalSubmitting}
            className="w-full text-left p-4 border-2 border-emerald-200 rounded-lg hover:border-emerald-400 hover:bg-emerald-50/40 transition disabled:opacity-50"
            data-testid="finaliser-terminer"
          >
            <div className="text-[10px] uppercase tracking-wider text-emerald-700 font-bold mb-1">
              Point final côté atelier
            </div>
            <div className="text-lg font-bold text-gray-900 mb-1 flex items-center gap-2">
              <CheckCircle2 className="w-5 h-5 text-emerald-600" /> Travaux terminés
            </div>
            <div className="text-xs text-gray-600">
              Le dossier part dans la file <em>"Factures à émettre"</em> (Facturation).
              L'édition de la facture et le choix du canal d'envoi (Caisse, Mail, Lixt,
              Courrier ou Hybride) se font là-bas.
            </div>
          </button>

          {finalSubmitting && (
            <div className="text-center text-sm text-gray-500">
              <Loader2 className="w-4 h-4 animate-spin inline mr-2" /> Clôture en cours...
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={finalSubmitting}>
            Annuler
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
